module.exports = __webpack_public_path__ + "img/Mea.c154adf0.svg";